module.exports = __webpack_public_path__ + "assets/img/thumb-Australian-Seniors-Landing-Page.115a077e.webp";